import { List } from '@material-tailwind/react';
import React from 'react';
import ListItemApc from './ListItemApc';

const ListaLocaisApc = ({ key, item }) => {
  return (
    <>
      <List className="w-full p-0 m-0 flex flex-col gap-2 pb-5">
        {item &&
          Object.entries(item).map(([key, geral], index) => (
            <ListItemApc index={index} array={geral} key={key} title={key} />
          ))}
      </List>
    </>
  );
};

export default ListaLocaisApc;
